import React from "react";

const Modal = (props: any) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
      }}
    >
      {props.children}
    </div>
  );
};

export default Modal;
